export const GET_INTENT = 'GET_INTENT';
export const LOAD_INTENTS = 'LOAD_INTENTS';
export const CREATE_INTENT = 'CREATE_INTENT';
export const UPDATE_INTENT = 'UPDATE_INTENT';
export const DELETE_INTENT = 'DELETE_INTENT';
